
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]/blog/page/[page]",
      function () {
        return require("private-next-pages/[pillar]/blog/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]/blog/page/[page]"])
      });
    }
  